import { mockOrderData } from 'external-quote/constants';

import {
  CustomerName,
  HeaderBottom,
  HeaderContainer,
  HeaderTop,
  ManageText,
  MetaInfo,
  MetaItem,
  MetaLabel,
  MetaValue,
  OrderInfo,
  OrderLabel,
  OrderNumber,
  StatusBadge,
} from './styles';

export const OrderHeader = () => {
  return (
    <HeaderContainer>
      <HeaderTop>
        <OrderLabel>Order</OrderLabel>
        <ManageText>Manage Sales Order</ManageText>
      </HeaderTop>
      <HeaderBottom>
        <OrderInfo>
          <OrderNumber>{mockOrderData.orderNumber}</OrderNumber>
          <CustomerName>{mockOrderData.customerName}</CustomerName>
          <StatusBadge>Saved</StatusBadge>
        </OrderInfo>

        <MetaInfo>
          <MetaItem>
            <MetaLabel>Order ID</MetaLabel>
            <MetaValue>{mockOrderData.orderId}</MetaValue>
          </MetaItem>

          <MetaItem>
            <MetaLabel>Source System</MetaLabel>
            <MetaValue>{mockOrderData.sourceSystem}</MetaValue>
          </MetaItem>

          <MetaItem>
            <MetaLabel>Submitted Date</MetaLabel>
            <MetaValue>{mockOrderData.submittedDate}</MetaValue>
          </MetaItem>

          <MetaItem>
            <MetaLabel>Order Status</MetaLabel>
            <MetaValue>{mockOrderData.orderStatus}</MetaValue>
          </MetaItem>
        </MetaInfo>
      </HeaderBottom>
    </HeaderContainer>
  );
};
